import {axiosInstance} from '@/services/axiosInstance'

export const MerchantBurealResource = {
  get: (parametros) => {
    return axiosInstance.get(
      'v1/merchantbureal/:id',
      {
        urlParams: parametros
       
      }
    )
  },

  getPerson2: (parametros) => {  
    
    return axiosInstance.get(
      `v1/merchantbureal/person`, 
      {
        urlParams: parametros
       
      }
     
    )
  },

  getZipcodeInfo: (parametros) => {
    return axiosInstance.get(
      'v1/merchantbureal/zipcode/:id',
      {
        urlParams: parametros
       
      }
    )
  },

}